// extracted by mini-css-extract-plugin
module.exports = {"disabledlink":"btncheckout_disabledlink__24jrI"};